"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.responsiveTypography = void 0;
var responsiveTypography_1 = require("./responsiveTypography");
Object.defineProperty(exports, "responsiveTypography", { enumerable: true, get: function () { return responsiveTypography_1.responsiveTypography; } });
//# sourceMappingURL=index.js.map